<template>
  <div class="container-fluid"  style="background-color: #F3F3F3" >

    <div class="section">
      <div class="columns has-text-left mx-0">
        <div
          class="is-clickable is-flex colour-secondary-01 is-underlined bold-l2 back-to-article column is-three-quarters mx-auto"
          @click="category == 'Events' ? $router.push('/happenings/events') : $router.push('/happenings/webinars')">
          <b-icon icon="menu-left" custom-size="is-large" style="font-size: 30px;"></b-icon>
          <span>Back to {{ category == 'Events' ? 'Events' : 'Webinars'}}</span>
        </div>
      </div>       
      </div>
     <div class="section-top">
       <p class="pb-title" style=" font-weight: 700; line-height: 45px; color: #2B2D47; !important;">
         REGISTRATION FORM
       </p>
       <p class="desc" style="font-weight: 400 !important; color: #2B2D47;">
         Please fill in the form below to register for the event.
       </p>
     </div>
     
     <div class="contact-column bg-white">
       <div class="">
         <div class="column is-three-quarters mx-auto">
           <validation-observer v-slot="{ handleSubmit, invalid }">
             <validation-provider :rules="{required: true, alpha_spaces: true, minName: 3}" v-slot="{ errors }">
               <b-field horizontal class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]" >
                <template #label >
                  First Name
                  <span style="color:red">*</span>
                </template>
                 <b-input v-model="inputFirstName" placeholder="Enter your First Name"></b-input>
               </b-field>
             </validation-provider>

             <validation-provider :rules="{required: true, alpha_spaces: true, minName: 3}" v-slot="{ errors }">
               <b-field horizontal class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]" >
                <template #label >
                  Last Name
                  <span style="color:red">*</span>
                </template>
                 <b-input v-model="inputLastName" placeholder="Enter your Last Name"></b-input>
               </b-field>
             </validation-provider>
             
             <ValidationObserver>
              <validation-provider rules="required|email" v-slot="{ errors }" name="inputEmail" >
               <b-field horizontal class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]" >
                <template #label >
                  Email Address
                  <span style="color:red">*</span>
                </template>
                 <b-input type="text" v-model="inputEmail" placeholder="Enter your Email Address"></b-input>
               </b-field>
             </validation-provider>

             <validation-provider rules="required|email|inputEmail:@inputEmail" v-slot="{ errors }">
               <b-field horizontal class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                <template #label >
                  Confirm Email Address
                  <span style="color:red">*</span>
                </template>
                 <b-input type="text" v-model="inputConfirmEmail" placeholder="Confirm your Email Address"></b-input>
               </b-field>
             </validation-provider>
             </ValidationObserver>           
 
             <validation-provider :rules="{required: true, integer: true, minPhone: 10, maxPhone: 11}" v-slot="{ errors }">
               <b-field horizontal class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]" style="width:100%">
                <template #label >
                  Contact No.
                  <span style="color:red">*</span>
                </template>
                   <b-input v-model="inputPhoneNo" placeholder="Enter your Contact Number" style="max-height: 40px;"></b-input>
               </b-field>
             </validation-provider>
 
             <!-- <validation-provider :rules="{required: true}" v-slot="{ errors }">
               <b-field horizontal label="Region" class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                <template #label>
                  Region
                  <span style="color:red">*</span>
                </template>
                 <b-select placeholder="Select your Region" v-model="inputRegion">
                     <option style="color: #7A7A7A !important" value="" disabled selected>Select your Region</option>
                     <option
                         v-for="option in region"
                         :value="option.name"
                         :key="option.value">
                         
                         {{ option.name}}
                     </option>
                 </b-select>
               </b-field>
             </validation-provider> -->

             <!-- <validation-provider :rules="{required: true, alpha_spaces: true, minName: 3}" v-slot="{ errors }">
               <b-field horizontal label="Job Title" class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                <template #label>
                  Job Title
                  <span style="color:red">*</span>
                </template>
                 <b-input type="text" v-model="inputJobTitle" placeholder="Enter your Job Title"></b-input>
               </b-field>
             </validation-provider> -->

             <!-- <validation-provider :rules="{required: true, alpha_spaces: true, minName: 3}" v-slot="{ errors }">
               <b-field horizontal label="Company" class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                <template #label>
                  Company
                  <span style="color:red">*</span>
                </template>
                 <b-input type="text" v-model="inputCompany" placeholder="Enter your Company"></b-input>
               </b-field>
             </validation-provider> -->
 
 
               <!-- <validation-provider  v-slot="{ errors }">
                 <b-field horizontal label="Introduced by" custom-class="is-medium" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                     <b-input type="text" v-model="inputAnswer" placeholder="Enter your answer"></b-input>
                 </b-field>
               </validation-provider> -->


             <validation-provider :rules="{required: true}" v-slot="{ errors }">
                <b-field horizontal :type="{ 'is-danger': errors[0] }" :message="errors[0]" style="text-align: left !important;" label=" ">
                  <template #label>
  
                  </template>
                    <b-checkbox v-model="isRead" class="has-text-left" style="font-weight:600;" size="is-normal" @click="isRead === !isRead">
                      YES, I have read and understood the AHAM Asset Management Berhad 
                      <a style="color:#730039;" class="is-underlined" href="https://aham.com.my/privacy-notice" target="_blank">Privacy Policy</a>.
                    </b-checkbox>
                </b-field>
              </validation-provider>
             
             <div class="captcha-wrapper">
               <VueRecaptcha
                 ref="recaptcha"
                 :sitekey=sitekey
                 :load-recaptcha-script="true"
                 @verify="handleSuccess"
                 @error="handleError"
                 @expired="handleExpired"
                 class="captcha-contact" 
               ></VueRecaptcha>
               <b-button 
               type="submit" 
               @click="handleSubmit(onSubmit(invalid, course.attributes.uuid))" 
               class="button dark-red" 
               icon-right="mdi mdi-play" 
               :disabled="invalid || !isVerify || !isRead"
               >
               Register
              </b-button>
             </div>
           </validation-observer>
         </div>
       </div>
       <div class="is-flex is-justify-content-end">
         <ScrollTop />
       </div>

       <b-modal v-model="registerSuccess" style="padding: 0 1rem;">
      <div class="modal-card" style="margin: auto;">
        <header class="modal-card-head pt-2 pb-2 pl-2 pr-2 modal-header"
          style="background: #730039; border-radius: 0px; height: 50px;">
          <p class="modal-card-title"></p>
          <b-button class="close-btn" style="background: transparent !important;" @click="registerSuccess = false"><b-icon
              icon="close" style="color:#FFFFFF; cursor: pointer; height: 100%"></b-icon></b-button>
        </header>

        <div class="modal-card-body pl-5 pr-5 pt-5 pb-5">
          <div class="has-text-centered">
            <div class="pop-up-text">
              <p class="pl-5 pr-5" style="color: #363636;">You have successfully registered for the event.</p>
              <div class="columns has-text-left mx-0">
        <div
          class="is-clickable is-flex colour-secondary-01 is-underlined bold-l2 column pt-5 mt-3 mb-3 is-justify-content-center is-align-items-center"  
          @click="category == 'Events' ? $router.push('/happenings/events') : $router.push('/happenings/webinars')">
          <b-icon icon="menu-left" custom-size="is-large" style="font-size: 30px;"></b-icon>
          <span>Back to {{ category == 'Events' ? 'Events' : 'Webinars'}}</span>
        </div>
      </div> 
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-loading :is-full-page="true" v-model="isLoading">
      <b-icon pack="mdi" icon="loading" size="is-large" custom-class="mdi-spin">
      </b-icon>
    </b-loading>

     </div>
   </div>
 </template>
 
 <script>
 import ScrollTop from '../components/ScrollTop.vue';
 import { defineComponent } from 'vue';
 import { VueRecaptcha } from 'vue-recaptcha';
 import { ValidationProvider, ValidationObserver} from 'vee-validate';
 import "@/pages/vee-validate.js";

 
 
   export default defineComponent({
     components: { ScrollTop, ValidationProvider, ValidationObserver, VueRecaptcha},
     data(){
       return{
          course: {},
          isConfirm: false,
          isLoading: false,
          registerSuccess: false,
          isModalActive: false,
          inputFirstName: '',
          inputLastName:'',
          inputEmail: '',
          inputConfirmEmail:'',
          inputPhoneNo: '',
          inputRegion: '',
          inputJobTitle: '',
          inputCompany:'',
          inputAnswer: '',
          isVerify: false,
          isRead: false,
          category:'',
          region: [
            {
              value: 0,
              name: "Perlis",
            }, 
            {
              value: 1,
              name: "Kedah",
            },
            {
              value: 2,
              name: "Penang",
            },
            {
              value: 3,
              name: "Perak",
            },
            {
              value: 4,
              name: "Selangor",
            },
            {
              value: 5,
              name: "Wilayah Persekutuan",
            },
            {
              value: 6,
              name: "Negeri Sembilan",
            },
            {
              value: 7,
              name: "Melaka",
            },
            {
              value: 8,
              name: "Johor",
            },
            {
              value: 9,
              name: "Pahang",
            },
            {
              value: 10,
              name: "Kelantan",
            },
            {
              value: 11,
              name: "Terengganu",
            },
            {
              value: 12,
              name: "Sabah",
            },
            {
              value: 13,
              name: "Sarawak",
            },
            {
              value: 14,
              name: "Wilayah Persekutuan Labuan",
            },
            {
              value: 15,
              name: "Wilayah Persekutuan Putrajaya",
            },
          ] 
        }
      },
     mounted(){
       window.scrollTo(0, 0);

       this.$httpClientCMS({
      method: "GET",
      url: "api/events?populate=*&filters[programType][$eq]=event&filters[uuid][$eq]=" + this.$route.query.courseId
    })
      .then(resp => {
        this.course = resp.data.data[0] ? resp.data.data[0] : this.course;
        if (resp.data.data.length > 0) {
          this.category = 'Events'
        }

      });
    this.$httpClientCMS({
      method: "GET",
      url: "api/events?populate=*&filters[programType][$eq]=webinar&filters[uuid][$eq]=" + this.$route.query.courseId
    })
      .then(resp => {
        this.course = resp.data.data[0] ? resp.data.data[0] : this.course;
        if (resp.data.data.length > 0) {
          this.category = 'Webinars'
        }
      });
     },
     methods: {
      register(courseId) {
        this.isConfirm = false;
        this.isLoading = true

        // POST to endpoint (public)
        this.$httpClient.post("/internal/pbmicrosite/register/" + courseId,
          {
            ParticipantType: 0,
            PbFirstname: this.inputFirstName.toString(),
            PbLastname: this.inputLastName.toString(),
            PbEmail: this.inputEmail.toString(),
            PbPhoneno: this.inputPhoneNo.toString()
          })
          .then(resp => {
            if (resp.data.EnrollStatus === true) {
              this.registerSuccess = true;
              this.modalActive = true;
              this.isLoading = false;
            }
          })
          .catch((error) => {
            this.$buefy.toast.open({
              message: 'This course is full, registration denied',
              type: 'is-danger'
            });
            this.registerSuccess = false;
            this.modalActive = false;
            this.isLoading = false;
          });

      },
      onSubmit(value,courseId) {
         if(value === false && this.isVerify === false){
           this.displayToast('Invalid Captcha', 'is-danger');
         }else if(value === false && this.isVerify === true && this.isRead === true){
           this.register(courseId);
         }
       },
       displayToast(message, type){
         this.$buefy.toast.open({
             message: message,
             type: type
         })
       },
       handleSuccess() {
         this.isVerify = true;
       },
       handleError() {
         alert('Server error!');
       },
       handleExpired() {
         this.$refs.recaptcha.reset();
         this.isVerify = false;
       },
     },
     computed: {
       sitekey(){
         return process.env.VUE_APP_RECAPTCHA_SITE_KEY;
       }
     },
     watch: {
    registerSuccess(value) {
      if (!value) {
        this.$nextTick(() => {
          location.reload();
        });
      }
    }
  }
   });
 </script>
 
 <style scoped lang="scss">

 .banner-section {
   background-position: left 20% center !important;
 }

 .section.breadcrumb{
  padding:  4rem 90px 0rem;
 }
 
 .section-top {
   background-color: #F3F3F3;
   padding: 0rem 0 5rem;
 
   .desc {
     margin: 1.5rem 1rem 0;
   }
 }
 
 
 
 .contact-column{
   padding: 4rem 90px 3.5rem;
 }

 .section{
   padding: 4rem 90px 2rem;
 }
 
 .field {
   margin-bottom: 2rem !important;
 }
 
 .b-radio.radio {
   color: #363636;
 }
 
 .purpose {
   .field {
     margin-bottom: 1.5rem !important;
   }
 }
 
 .message-field {
   .field {
     margin-bottom: 0.5rem !important;
   }
 }
 
 .captcha-wrapper {
   max-width: 243px; 
   text-align: left; 
   margin-left: 19%;
 }
 .captcha-contact{
   transform:scale(0.8);
   -webkit-transform:scale(0.8);
   transform-origin:0 0;
   -webkit-transform-origin:0 0;
   margin-bottom: 2rem;
 }
 
 @media screen and (max-width: 1660px) {
   .section-top {
     background-color: #F3F3F3;
     padding: 0rem 0 4rem;
 
     .desc {
       margin: 1rem 1rem 0;
     }
   }

 }
 
 @media screen and (max-width:1290px) and (min-width: 1024px){
   .contact-column{
     padding-left: 45px !important;
     padding-right: 40px !important;
   }

   .section{
     padding-left: 45px !important;
     padding-right: 40px !important;
   }
   
 }
 
 @media screen and (max-width: 1023px) {
   .contact-column{
     padding-left: 10px !important;
     padding-right: 20px !important;
     padding-top: 2.5rem;
   }

   .section{
     padding-left: 10px !important;
     padding-right: 20px !important;
     padding-top: 2.5rem;
   }
 
   .section-top {
     padding:0rem 0 2.5rem;
     .desc {
       margin: 0.5rem 1rem 0;
     }
   }
 }
 
 @media (min-width: 769px) and (max-width: 920px) {
   :deep() {
     .b-radio.radio.know-more {
       align-items: flex-start;
       .check {
         margin-top: 3px;
       }
     }
   }
 }
 
 @media (max-width: 575px) {
   :deep() {
     .b-radio.radio.know-more {
       align-items: flex-start;
       .check {
         margin-top: 3px;
       }
     }
   }
 }
 
 @media screen and (max-width: 768px) {
 
   .captcha-wrapper {
     margin-left: 0;
     .captcha-contact {
       margin: 2rem 0;
     }
     
   }
 
   .subtitle {
     font-weight: 400;
   }
   // .contact-column{
   //   margin-bottom: 180px !important;
   // }
 }
 
 @media screen and (min-width: 1661px) {
 }
 
 </style>
 